import i18n from "../../../../constants/i18n";
import { USER_CONVERSATIONS_HEADERS } from "../../../../constants/table-custom-headers/User";
import getUserConversationStore from "../../../../stores/user-store/conversation-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import LoadMoreButton from "./LoadMoreButton";
import React from "react";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import getUserMessagesStore from "../../../../stores/user-store/messages-store";
import SocialMediaBadWordsCounter from "../../../../components/SocialMediaBadWordsCounter";

const ConversationData = withLiteObserverAndTheme(() => {
  const converationData = getUserConversationStore().conversationData.get();
  const { senderUsername, recipientUsername } = converationData;
  const conversation = getUserConversationStore().getMessagesData();

  const socialMediaBadWordsCount =
    getUserMessagesStore().getBadWordsAndSocialMediaCount(conversation);

  return (
    <React.Fragment>
      <SocialMediaBadWordsCounter
        socialMediaBadWordsCount={socialMediaBadWordsCount}
      />
      <Et3Margin top={10} bottom={10} left={0} right={0} />
      <Et3Table
        columns={USER_CONVERSATIONS_HEADERS}
        rows={conversation}
        title={i18n.getWithExtraData(
          "MESSAGES_SEND_FROM",
          `${senderUsername} and ${recipientUsername}`
        )}
        shouldBeFlagged={false}
        titleKey={"MESSAGES_SENT_BETWEEN"}
      />
      <Et3Margin top={10} bottom={10} left={0} right={0} />
      <LoadMoreButton />
    </React.Fragment>
  );
});
export default ConversationData;
